import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import Main from "./components/Main";
import BlogPost from "./components/BlogPost";
import TagPage from "./components/TagPage";
import About from "./components/About";
import Portfolio from "./components/Portfolio";
import PortfolioBackend from "./components/PortfolioBackend";
import PortfolioDevOps from "./components/PortfolioDevOps";
import LibraryPage from "./components/Library/LibraryPage";
import AddInspirationForm from "./components/Library/AddInspirationForm";
import NotFound from "./components/NotFound";

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="min-h-screen bg-background">
          <Routes>
            <Route path="/" element={<Main />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/tags/:tag" element={<TagPage />} />
            <Route path="/about" element={<About />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/portfolio/backend" element={<PortfolioBackend />} />
            <Route path="/portfolio/devops" element={<PortfolioDevOps />} />
            <Route path="/library" element={<LibraryPage />} />
            <Route path="/admin/add-inspiration" element={<AddInspirationForm />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
